/**
 * The API origin.
 *
 * Its own module because `client.ts` needs the auth store (for the token) and
 * the auth store needs the origin (to refresh) — importing the constant from
 * `client.ts` closed a cycle, which dependency-cruiser rejects and which would
 * make either file impossible to move later. One value in one leaf module costs
 * nothing and breaks it.
 *
 * It is now set by the host application rather than read from `import.meta.env`
 * directly. This package is compiled by `tsc` and shipped as `dist/`, so a bare
 * `import.meta.env.VITE_API_URL` here would sit inside node_modules where Vite's
 * build-time substitution is not guaranteed to reach it — the failure mode is a
 * production bundle that silently talks to localhost. Each app reads its own env
 * where the Vite types actually exist and calls `configureApiBase` once, before
 * render.
 */
const DEFAULT_API_BASE = 'http://localhost:3111';
let apiBase = DEFAULT_API_BASE;
/**
 * Call once from the app entrypoint, before the first render. Passing a
 * nullish value keeps the local-development default rather than producing
 * requests against `undefined/...`.
 */
export function configureApiBase(url) {
    apiBase = url && url.length > 0 ? url.replace(/\/$/, '') : DEFAULT_API_BASE;
}
/** Read at call time, never at module time — see `configureApiBase`. */
export function getApiBase() {
    return apiBase;
}
//# sourceMappingURL=base.js.map